export default "__VITE_ASSET__CtRvCJIn__"